import script from "./ListarColores.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarColores.vue?vue&type=script&setup=true&lang=js"

import "@/assets/plantilla/dataList.css?vue&type=style&index=0&id=2e7b6f5a&scoped=true&lang=css"
import "./ListarColores.vue?vue&type=style&index=1&id=2e7b6f5a&scope=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e7b6f5a"]])

export default __exports__